import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=3012fdc7&scoped=true&"
var script = {}
import style0 from "./ListLayout.vue?vue&type=style&index=0&id=3012fdc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012fdc7",
  null
  
)

export default component.exports